import { v4 as uuidv4 } from "uuid";
import type { TableRow, TextRow, AreaRow } from "./types";
import { defaultIconNameForType } from "./helpers";

// Converte um elemento do mapa (vindo de useMapa().elements) em uma linha da
// tabela, para a aba de edição em massa. Espelha a forma usada pelo fluxo de
// adição, preenchendo os campos extras necessários ao update (elementId, font,
// produtoId).
export function elementToRow(el: any, iconsElement: any[] = []): TableRow {
  const tipo = el?.tipo;
  const type: TableRow["type"] =
    tipo === 0 ? "Host" : tipo === 1 ? "Mapa" : "POP";

  const config = el?.elementConfig?.config || {};
  const host0 = config.hosts?.[0];

  const selectedName =
    type === "Host"
      ? (host0?.host ?? null)
      : (el?.mapRef?.titulo ?? el?.titulo ?? null);

  // O grid trabalha com o NOME do ícone; o elemento guarda o UUID em `img`.
  // POP/Mapa frequentemente têm img=null → cai no ícone padrão do tipo (mesmo
  // comportamento do fluxo de adição e da renderização do mapa). Necessário
  // também porque o ícone é obrigatório na validação.
  const iconId =
    iconsElement.find((i: any) => i.id === el?.img)?.nome ??
    defaultIconNameForType(type, iconsElement);

  return {
    // `id` é apenas identidade da linha (não vai no payload de update).
    id: el?.id ?? uuidv4(),
    // mapRef referenciado (POP/Mapa); Host não referencia mapa.
    mapRefId: type !== "Host" ? (el?.mapRefId ?? el?.mapRef?.id ?? null) : null,
    elementId: el?.id,
    type,
    selectedName,
    title: el?.titulo ?? null,
    iconId,
    lat: config.coordenadas?.lat ?? null,
    long: config.coordenadas?.long ?? null,
    // Preserva os itens do host (não há coluna de itens; evita zerar no save).
    hostItems: host0?.itens ?? [],
    description: config.descricao ?? null,
    // Tags ficam no nível superior do elemento (espelha o payload de save).
    tags: Array.isArray(el?.tags) ? el.tags : [],
    produtoId: config.produtoId,
    font: el?.font ?? null,
    _errors: {},
    checked: false,
  };
}

// Converte um elemento Texto (tipo 3) em linha da tabela de edição. Guarda o
// config original em `_origConfig` para preservar campos não editados no save.
export function textElementToRow(el: any): TextRow {
  const config = el?.elementConfig?.config || {};
  const box = config.box || {};
  return {
    id: el?.id ?? uuidv4(),
    elementId: el?.id,
    mode: box.mode === "html" ? "html" : "text",
    content: box.content ?? "",
    textColor: box.textColor ?? "",
    backgroundColor: box.backgroundColor ?? "",
    lat: config.coordenadas?.lat ?? null,
    long: config.coordenadas?.long ?? null,
    titulo: el?.titulo ?? "",
    font: el?.font ?? null,
    tags: Array.isArray(el?.tags) ? el.tags : [],
    img: el?.img ?? null,
    mapRefId: el?.mapRefId ?? el?.mapRef?.id ?? null,
    _origConfig: config,
    _errors: {},
  };
}

// Converte um elemento Área (tipo 4) em linha da tabela de edição. Os pontos do
// polígono NÃO são copiados para a linha — ficam só em `_origConfig` e são
// preservados intactos no save.
export function areaElementToRow(el: any): AreaRow {
  const config = el?.elementConfig?.config || {};
  const polygon = config.polygon || {};
  return {
    id: el?.id ?? uuidv4(),
    elementId: el?.id,
    titulo: el?.titulo ?? "",
    color: polygon.color ?? "",
    font: el?.font ?? null,
    tags: Array.isArray(el?.tags) ? el.tags : [],
    img: el?.img ?? null,
    mapRefId: el?.mapRefId ?? el?.mapRef?.id ?? null,
    _origConfig: config,
    _errors: {},
  };
}
